export default __webpack_public_path__ + "static/media/recharge.b1f24ef9.svg";